import { render } from "./BadgeComponent.vue?vue&type=template&id=f7cff0a8"
import script from "./BadgeComponent.vue?vue&type=script&lang=js"
export * from "./BadgeComponent.vue?vue&type=script&lang=js"

import "./BadgeComponent.vue?vue&type=style&index=0&id=f7cff0a8&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__